import { Close } from "@mui/icons-material";
import { Button, IconButton, Modal, Paper } from "@mui/material";
import React from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { FormProvider, RHFTextField } from "../../../components/hook-form";
import { CLOSE_EDIT_ABOUTME, CLOSE_EDIT_INTERESTS } from "../../../redux/types";
import RHFSelectField from "../../../components/hook-form/RHFSelect";
import { updateProfile } from "../../../redux/actions/profileActions";

const EditAboutMe = () => {
  const { openAboutme: open } = useSelector((state) => state.ModalsControl);

  const aboutMeSchema = Yup.object().shape({
    mbti: Yup.string(),
    education: Yup.string(),
    occupation: Yup.string(),
    age: Yup.number(),
    bodyType: Yup.string(),
    location: Yup.string(),
    height: Yup.number(),
  });

  const defaultValues = {
    education: "",
    occupation: "",
    mbti: "",
    height: 0,
    location: "",
    bodyType: "",
    age: 0,

    // remember: true,
  };

  const methods = useForm({
    resolver: yupResolver(aboutMeSchema),
    defaultValues,
  });

  const {
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  const onSubmit = (values) => {
    console.log({ values });
    dispatch(updateProfile(values));
    dispatch({ type: CLOSE_EDIT_ABOUTME });
  };
  const dispatch = useDispatch();
  return (
    <Modal
      className="grid place-items-center  overflow-scroll "
      open={open}
      onClose={() => dispatch({ type: CLOSE_EDIT_ABOUTME })}>
      <Paper elevation={8} className="!bg-slate-100 p-2 w-[90%] my-4   ">
        <IconButton
          className="absolute top-0 left-4"
          onClick={() => dispatch({ type: CLOSE_EDIT_ABOUTME })}>
          <Close />
        </IconButton>

        <FormProvider
          methods={methods}
          classes=" shadow-lg border-slate-100 rounded-lg p-6 mt-4   bg-white grid place-items"
          onSubmit={handleSubmit(onSubmit)}>
          <RHFTextField
            label="How old are you?"
            name="age"
            outerClasses="flex flex-col sm:flex-row items-center child:first:w-full child:!mb-0 child:mr-4 mb-4"
          />
          <RHFTextField
            label="Where do you live?"
            name="location"
            outerClasses="flex flex-col sm:flex-row items-center child:w-full child:first:!mb-0 child:mr-4 mb-4"
          />
          <RHFTextField
            label="Where did your occupation"
            name="occupation"
            outerClasses="flex flex-col sm:flex-row items-center child:w-full child:first:!mb-0 child:mr-4 mb-4"
          />
          {/* select */}
          <RHFTextField
            label="Where is did you study?"
            name="education"
            outerClasses="flex flex-col sm:flex-row items-center child:w-full child:first:!mb-0 child:mr-4 mb-4"
          />
          {/* <RHFTextField  label="Where is your languages" name="langs" outerClasses="flex flex-col sm:flex-row items-center child:w-full child:first:!mb-0 child:mr-4 mb-4"/> */}
          <RHFTextField
            type="number"
            label="How tall are you?"
            name="height"
            outerClasses="flex flex-col sm:flex-row items-center child:w-full child:first:!mb-0 child:mr-4 mb-4"
          />
          {/* <RHFSelectField label="what is your body type?" name="bodyType">
            <option value=""></option>
            <option value="Average">Average</option>
            <option value="Athletic">Athletic</option>
            <option value="Slim">Slim</option>
            <option value="Slim">Muscular</option>
          </RHFSelectField> */}

          <RHFSelectField label="what is your mbti?" name="mbti">
            <option value=""></option>
            <option value="INTJ">INTJ</option>
            <option value="INTP">INTP</option>
            <option value="ENTP">ENTP</option>
            <option value="ENTJ">ENTJ</option>

            <option value="ENFJ">ENFJ</option>
            <option value="ENFP">ENFP</option>
            <option value="INFJ">INFJ</option>
            <option value="INFP">INFP</option>

            <option value="ISFJ">ISFJ</option>
            <option value="ISFP">ISFP</option>
            <option value="ESFP">ESFP</option>
            <option value="ESFJ">ESFJ</option>

            <option value="ISTJ">ISTJ</option>
            <option value="ISTP">ISTP</option>
            <option value="ESTP">ESTP</option>
            <option value="ESTJ">ESTJ</option>
          </RHFSelectField>
          <Button type="submit" variant="contained" className="!bg-rose-500">
            save
          </Button>
        </FormProvider>
      </Paper>
    </Modal>
  );
};

export default EditAboutMe;
